import logo1 from "../assets/image/logo1.png";
import {
  NavLink,
  Link
} from "react-router-dom";
import "../index.css";
import { useEffect, useState } from "react";

function Navbar() {
  const [hideTopBar, setHideTopBar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setHideTopBar(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <section className="fixed-top">
        {/* Topbar */}
        <div
          className={`bg-warning py-1 text-dark topbar ${
            hideTopBar ? "hide" : ""
          }`}
        >
          <div className="container-fluid px-md-5 py-1 d-flex justify-content-between align-items-center flex-wrap text-center small">
            <div className="me-auto fw-bold text-primary">
              <a
                href="mailto:info@acwa.com"
                className="text-primary text-decoration-none"
              >
                📧 Innovations.Enterprises@rediffmail.com 
              </a>
            </div>
            <div className="mx-auto fw-bold text-primary">
              <a
                href="tel:9876543210"
                className="text-primary text-decoration-none"
              >
                📞 +91 9893118833
              </a>
            </div>
            <div className="ms-auto fw-bold text-primary">
              <a
                href="https://www.google.com/maps/place/Bhopal,+Madhya+Pradesh"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary text-decoration-none"
              >
                📍 Bhopal, Madhya Pradesh
              </a>
            </div>
          </div>
        </div>

        {/* Navbar */}
        <nav
          className={`navbar bg-light navbar-expand-lg ${
            hideTopBar ? "shift-up" : "shift-down"
          }`}
        >
          <div className="container-fluid px-md-5">
            <NavLink to="/">
              <img
                src={logo1}
                alt="Logo"
                width="150"
                data-aos="flip-right"
                data-aos-once="false"
              />
            </NavLink>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav mx-auto">
                {["/", "/about", "/services", "/contact"].map((path, i) => (
                  <li
                    key={i}
                    className="nav-item fw-semibold"
                    data-aos="flip-up"
                    data-aos-once="false"
                  >
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "nav-link active-link" : "nav-link"
                      }
                      to={path}
                    >
                      {path === "/" ? "Home" : path.replace("/", "").replace(/^\w/, c => c.toUpperCase())}
                    </NavLink>
                  </li>
                ))}
                <li
                  className="nav-item fw-semibold"
                  data-aos="flip-up"
                  data-aos-once="false"
                >
                  <div
                    className="d-sm-none mb-3 mt-1 d-block"
                    data-aos="flip-left"
                    data-aos-once="false"
                  >
                    <Link to="/enquiry">
                      <button type="button" className="btn btn-primary">
                        ENQUIRY NOW
                      </button>
                    </Link>
                  </div>
                </li>
              </ul>
            </div>
            <div
              className="d-none d-sm-block"
              data-aos="flip-left"
              data-aos-once="false"
            >
              <Link to="/enquiry">
                <button type="button" className="btn btn-primary">
                  ENQUIRY NOW
                </button>
              </Link>
            </div>
          </div>
        </nav>
      </section>

      {/* Spacer for fixed top */}
      <div style={{ height: "120px" }}></div>
    </>
  );
}

export default Navbar;
